import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardContent from "@mui/material/CardContent";
import * as groupTemplateActions from "../../../actions/groupTemplateActions";
import QuestionContainer from "../questions/QuestionContainerHook";
import GroupEditor from "./GroupEditorHook";


const GroupContainerHook = ({ templateKey: propTemplateKey, match = {} }) => {
    const [templateKey, setTemplateKey] = useState("");
    const template = useSelector(state => state.groupTemplate);
    const dispatch = useDispatch();

    useEffect(() => {
        let resolvedTemplateKey;
        if (!propTemplateKey) {
            resolvedTemplateKey = match.params?.templateKey || "";
        } else {
            resolvedTemplateKey = propTemplateKey;
        }
        setTemplateKey(resolvedTemplateKey);
        dispatch(groupTemplateActions.getGroupTemplate(resolvedTemplateKey));
    }, [propTemplateKey, match.params?.templateKey, dispatch]);

    const getHtml = () => {
        let html;

        if (template !== undefined) {
            html = (
                <div id="GroupContainer-container-div">
                    <Card>
                        <CardHeader
                            title={"Group: " + (template[templateKey] ? template[templateKey].name : "")}
                            titleTypographyProps={{color: "#29b173"}}
                            subtitle={"Key: "+templateKey}
                            actAsExpander
                        >
                            {/*<GroupReview template={template[templateKey]} />*/}
                        </CardHeader>
                        <CardContent expandable>
                            <GroupEditor template={template[templateKey]} width="90%" scrollTo="GroupContainer-container-div"/>
                        </CardContent>
                        <CardContent>
                            {
                                template[templateKey] !== undefined ?
                                    template[templateKey].questionKeys.map(function (questionKey) {
                                        return <QuestionContainer key={questionKey} templateKey={questionKey} />;
                                    })
                                    : ""
                            }
                        </CardContent>
                    </Card>
                </div>
            );
        } else {
            html = <div />;
        }
        return html;
    };

    return getHtml();
};

GroupContainerHook.defaultProps = {
    match: {},
    templateKey: ""
};

GroupContainerHook.propTypes = {
    templateKey: PropTypes.string,
    match: PropTypes.object
};

export default GroupContainerHook;